<template>
  <div>
    <Linkedin-Company :companyData="companyData" />
  </div>
</template>

<script>
import LinkedinCompany from '@/components/LinkedinCompany.vue'
import {
  setCookie,
  readCookie,
  postDomChangeAlert
} from '@/assets/util/commonUtil'
import { companyParser } from '../domParser/parser'
import { LI_PARSER_ERROR } from '@/assets/util/constants/constants'

export default {
  name: 'SingleProfileView',
  components: {
    'Linkedin-Company': LinkedinCompany
  },
  data: function() {
    return {
      companyData: null
    }
  },
  methods: {
    addListenerForMsgFromPlugin() {
      const that = this
      window.addEventListener(
        'message',
        function(ev) {
          if (ev && ev.data && ev.data.type == 'li-company') {
            console.log(ev)
            if (ev.data.data) {
              const data = ev.data.data
              if (
                data.isServerParserEnabled !== undefined &&
                data.isServerParserEnabled === true
              ) {
                const config = {}
                config.htmlText = data.profileHTML ? data.profileHTML : ''
                config.currentUrl = data.currentUrl ? data.currentUrl : ''
                config.isProspectorParser = true
                companyParser(config).then(function(parsedData) {
                  if (
                    parsedData &&
                    parsedData.domReadError !== undefined &&
                    parsedData.domReadError
                  ) {
                    if (readCookie(LI_PARSER_ERROR.COMPANY) == null) {
                      const reportConfig = {
                        html: config.htmlText,
                        liUrl: config.currentUrl,
                        version: 'server-company'
                      }
                      setCookie(LI_PARSER_ERROR.COMPANY, 'true', 0, 1)
                      postDomChangeAlert(reportConfig)
                    }
                  }
                  let salesNavUrl = ''
                  try {
                    const url = new URL(config.currentUrl)
                    const path = url.pathname
                    salesNavUrl =
                      url.origin + (path.endsWith('/') ? path : path + '/')
                  } catch (e) {
                    salesNavUrl = config.currentUrl
                  }
                  that.companyData = {
                    ...parsedData,
                    salesNavUrl: salesNavUrl
                  }
                })
              } else if (
                data.domReadError !== undefined &&
                data.domReadError === true
              ) {
                const config = {}
                config.htmlText = data.profileHTML ? data.profileHTML : ''
                config.currentUrl = data.currentUrl ? data.currentUrl : ''
                config.isProspectorParser = true
                companyParser(config).then(function(parsedData) {
                  if (
                    parsedData &&
                    parsedData.domReadError !== undefined &&
                    parsedData.domReadError
                  ) {
                    if (readCookie(LI_PARSER_ERROR.COMPANY) == null) {
                      const reportConfig = {
                        html: config.htmlText,
                        liUrl: config.currentUrl,
                        pageUrl: 'company'
                      }
                      setCookie(LI_PARSER_ERROR.COMPANY, 'true', 0, 1)
                      postDomChangeAlert(reportConfig)
                    }
                  }
                  that.companyData = parsedData
                })
              } else {
                that.companyData = ev.data.data
              }
            }
          }
        },
        true
      )
    }
  },
  beforeMount: function() {
    this.addListenerForMsgFromPlugin()
  }
}
</script>
